import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { HiddenValueProperties, useHiddenValueProperties } from "./HiddenValueProperties";

import { DraftHiddenValueComponent } from "./DraftHiddenValueComponent";
import { HiddenValueField } from "./HiddenValueField";
import { IControlAttributes } from "../../../../../base/models";
import { Registry } from "../../../../../base/register";
import { SimpleHiddenValue } from "./SimpleHiddenValue";

export const HiddenValueComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useHiddenValueProperties(props);

    const getHiddenValueNode = useCallback(() => {
        const binding = bindings?.getBinding(Property.Field);
        switch (binding?.type) {
            case "Field":
                return <HiddenValueField
                    id={control.controlId}
                    name={binding.boundValue}
                    {...properties}
                    className={className}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleHiddenValue
                    id={control.controlId}
                    {...properties}
                    value={binding?.value}
                    className={className}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>{getHiddenValueNode()}</>
}

Registry.addControl({
    id: "b54e4d2c-1d02-47e4-86fe-daebaf80bc58",
    name: "Hidden Field",
    type: ControlType.HiddenInput,
    properties: HiddenValueProperties,
    component: HiddenValueComponent,
    draftComponent: DraftHiddenValueComponent
})
